'use strict';

import { invitationModel } from "../../models/invitationmodel.js";
import { annexModel } from "../../models/annexmodel.js";

export class InvitationEditCtrl {
	$scope;
	$filter;
	jsDataService;
	item = {};
	navList = {};
	postFields = {};
	optional_fields = {};
	annex_fields = {};
	postData = {};

	constructor($scope, $filter, jsDataService) {
		'ngInject';
		this.$scope = $scope;
		this.$filter = $filter;
		this.jsDataService = jsDataService;
		this.classif = this.jsDataService.get('cfgClassif', {});
		this.item = new invitationModel(jsDataService.get('invitation', {}), $filter, jsDataService);
		if (typeof this.item.opening !== 'undefined' && this.item.opening > 0) {
			this.item.opening = new Date(this.item.opening * 1000);
		} else {
			this.item.opening = null;
		}
		if (typeof this.item.deadline !== 'undefined' && this.item.deadline > 0) {
			this.item.deadline = new Date(this.item.deadline * 1000);
		} else {
			this.item.deadline = null;
		}
		this.navList = this.jsDataService.get('navList', {});
		this.postFields = this.jsDataService.get('postFields', {});
		this.optional_fields = this.item.optional_fields[this.jsDataService.get('section')];
		const prefix = 'ESF-SI-';
		this.item.number = this.item.number?.startsWith(prefix)
			? this.item.number.substring(prefix.length)
			: this.item.number;
	}

	static circularReplacer() {
		const seen = new WeakSet();
		return function (key, value) {
			if (typeof value === 'object' && value !== null) {
				if (seen.has(value)) {
					return;
				}
				seen.add(value);
			}
			return value;
		};
	}

	addField = function () {
		this.optional_fields.push({ title: '', value: '', ord: this.optional_fields.length });
	};

	addAnnexField = function () {
		this.item.annexes.push(
			new annexModel(
				{ title: '', explain: '', mandatory: false, ord: this.item.annexes.length },
				this.$filter,
				this.jsDataService
			)
		);
	};

	removeField = function (index) {
		this.optional_fields.splice(index, 1);
		this.triggerAutosave();
	};

	removeAnnexField = function (index) {
		this.item.annexes.splice(index, 1);
		this.triggerAutosave();
	};

	fieldValue(field) {
		if (typeof this.item[field] === 'undefined') {
			return '';
		}
		let val = this.item.getValue(field);
		switch (field) {
			case 'objectives':
				return this.$filter('nl2br')(val);
		}
		return val;
	}

	sectionFieldVisible(fldCfg) {
		if (!fldCfg.show) {
			return false;
		}
		if (
			typeof this.item[fldCfg.idkey + '_on'] !== 'undefined' &&
			(this.item[fldCfg.idkey + '_on'] != 1 || false === this.item[fldCfg.idkey + '_on'])
		) {
			return false;
		}
		return true;
	}

	sectionFieldValue(fldCfg) {
		return this.fieldValue(fldCfg.idkey);
	}

	sectionDisplay(section) {
		if (
			typeof section.fields !== 'undefined' &&
			Object.values(section.fields).some((item) => {
				return item.show === true;
			})
		) {
			return true;
		}
		if (this.item.hasOptionalFields(section.idkey)) {
			return true;
		}
		return false;
	}

	back = function () {
		const url = this.jsDataService.get('previousUrl');
		if (url) {
			this.$scope.goUrl(url);
		}
	};

	cancel = function () {
		const url = this.jsDataService.get('previewUrl');
		if (url) {
			this.$scope.goUrl(url);
		}
	};

	saveAndHref = function () {
		this.setPostData();
		this.postData.gotoNext = true;
		this.saveData();
	};

	save = function () {
		this.setPostData();
		this.postData.gotoNext = false;
		this.saveData();
	};

	saveAnnex = function () {
		let annexes = [];
		for (let annex of this.item.annexes) {
			annexes.push(annex.getData());
		}
		this.postData.id = this.item.id;
		this.postData.annexes = annexes;
		this.saveData();
	};

	saveData = function () {
		const saveUrl = this.jsDataService.get('saveUrl');
		if (saveUrl) {
			this.$scope.basicHttpConfigProcess({
				url: saveUrl,
				method: 'POST',
				data: this.postData,
				headers: { 'Content-Type': 'application/json' },
				transformRequest: [
					(data) => JSON.stringify(data, InvitationEditCtrl.circularReplacer())
				]
			}).then((response) => {
				if(typeof(response.data.data.optional_fields) !== 'undefined' && typeof(response.data.data.optional_fields[this.jsDataService.get('section')]) !== 'undefined'){
					const responseFields = response.data.data.optional_fields[this.jsDataService.get('section')];
					for(let i = 0; i < Math.min(responseFields.length, this.optional_fields.length); i++){
						this.optional_fields[i].id = responseFields[i].id;
					}
				}
				if(this.jsDataService.get('section') === 'annexes' && this.item.hasAnnexes() && typeof(response.data.data.annexes) !== 'undefined'){
					const responseAnnexes = response.data.data.annexes;
					for(let i = 0; i < Math.min(responseAnnexes.length, this.item.annexes.length); i++){
						this.item.annexes[i].id = responseAnnexes[i].id;
					}
				}

			});
		}
		return null;
	};

	setPostData() {
		this.postData = this.item.getData();
		if (this.postData.deadline_cet instanceof Date) {
			this.postData.deadline = this.$filter('date')(this.postData.deadline_cet, 'yyyy-MM-dd HH:mm');
		}
		if (this.postData.opening_cet instanceof Date) {
			this.postData.opening = this.$filter('date')(this.postData.opening_cet, 'yyyy-MM-dd');
		}
	}

	autosavePostFields() {
		this.setPostData();
		this.postData.gotoNext = null;
		this.saveData();
	}

	triggerAutosave() {
		this.$scope.$broadcast('autosaveFormChanged', {});
	}
}
